export default __webpack_public_path__ + "static/media/BookTextbook.80d07249.png";